import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { isAuthenticated } from '../../services/authService';
import Card from '../../components/common/Card';
import Button from '../../components/forms/Button';
import './Home.css';

const Home = () => {
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    // Check authentication status
    const checkAuth = () => {
      setAuthenticated(isAuthenticated());
    };

    checkAuth();

    // Listen for custom authChange event (for same-tab login/logout)
    window.addEventListener('authChange', checkAuth);

    // Listen for storage changes (in case user logs in/out in another tab)
    window.addEventListener('storage', checkAuth);

    return () => {
      window.removeEventListener('authChange', checkAuth);
      window.removeEventListener('storage', checkAuth);
    };
  }, []);

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
           <h1 className="hero-title">
              Welcome to Sort My Spot <br />
              Onboarding
            </h1>
            <p className="hero-subtitle">
              Established in 2022, Sort my spot aims to provide customized packages 
              for your next trip to Nepal, providing great offers, competitive hotel
               prices, exclusive discounts, and a seamless online booking experience 
               to its customers. We bring you pleasure of creating your travel plans
                from scratch hassle-free through our desktop site or mobile app. To 
                save efforts we also provide Pre-planned packages for Individual, 
                families and corporates loaded with added benefits, such as Site seeing,
                 Tour guides and many more things.
            </p>
            <div className="hero-actions">
              {authenticated ? (
                <>
                  <Link to="/dashboard">
                    <Button variant="primary" className="btn-lg me-3">
                      Go to Dashboard
                    </Button>
                  </Link>
                 
                </>
              ) : (
                <>
                  <Link to="/login">
                    <Button variant="primary" className="btn-lg me-3">
                      Get Started
                    </Button>
                  </Link>
                  <Link to="/login">
                    <Button variant="outline-primary" className="btn-lg">
                      Login
                    </Button>
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2 className="section-title">Why Choose Us?</h2>
          <div className="features-grid">
            <Card className="feature-card">
              <div className="feature-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
              </div>
              <h3>Easy Hotel Registration</h3>
              <p>
                Register your hotels quickly with our simple and intuitive onboarding process.
                Add all details, amenities, and photos in minutes.
              </p>
            </Card>

            <Card className="feature-card">
              <div className="feature-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                  <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                </svg>
              </div>
              <h3>Comprehensive Dashboard</h3>
              <p>
                Access all your hotel information, bookings, and analytics from a single,
                easy-to-use dashboard.
              </p>
            </Card>

            <Card className="feature-card">
              <div className="feature-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
              </div>
              <h3>24/7 Support</h3>
              <p>
                Get round-the-clock support from our dedicated team to ensure your hotel
                operations run smoothly.
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      {!authenticated && (
        <section className="cta-section">
          <div className="container">
            <div className="cta-content">
              <h2>Ready to Get Started?</h2>
              <p>Join thousands of hotels already using our platform</p>
              <Link to="/login">
                <Button variant="light" className="btn-lg">
                  Create an Account
                </Button>
              </Link>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default Home;
